














































































































// eslint-disable-next-line
import Vue from "vue";

const texts = ["her", "his"];
let index = 0;
setInterval(() => { 
  index %=  2;
  document.getElementById("change-text")!.innerText = texts[index];
  index++;
}, 1000);
